<template>
  <span>
    <div class="v-toolbar__button" @click="share">
      <v-icon icon="ios_share" />
    </div>

    <alert-dialog
      :title="$t('components.toolbar.shareButton.link')"
      :show="showAlert"
      :actions="[{ title: $t('components.toolbar.shareButton.copyLink'), callback: copy }]"
      @close="() => (showAlert = false)"
    >
      {{ copyUrl }}
    </alert-dialog>
    <input ref="urlInput" :value="copyUrl" type="text" class="copy-input" />
  </span>
</template>

<script>
import copy from "@/lib/copy"

import AlertDialog from "@/components/AlertDialog"

export default {
  components: {
    AlertDialog
  },

  props: {
    url: { type: String }
  },

  data() {
    return {
      showAlert: false,
      copyUrl: ""
    }
  },

  methods: {
    share() {
      if (window.navigator.share) {
        window.navigator
          .share({ url: this.copyUrl })
          .then(() =>
            this.$notify(this.$t("components.toolbar.shareButton.thanksForSharing"))
          )
      } else {
        this.showAlert = true
      }
    },

    copy() {
      copy(this.$refs.urlInput).then(() => {
        this.showAlert = false

        this.$notify(this.$t("components.toolbar.shareButton.linkCopied"))
      })
    }
  },

  mounted() {
    this.copyUrl = this.url ? this.url : window.location.href
  }
}
</script>
